// Images
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'custom-event-polyfill';

import fitty from 'fitty';

// Vue apps
import '../vue/favourite-products';
import '../vue/committees/index';
import '../vue/committees/entry';
import '../vue/jobs/index';
import '../vue/jobs/configuration/index';
import '../vue/jobs/update/index';
import '../vue/jobs/calculators/system-performance/index';
import '../vue/jobs/calculators/voltage-rise/index';
import '../vue/jobs/calculators/dc-isolator';
import '../vue/jobs/calculators/string-fuse-tool';
import '../vue/jobs/commissioning-sheet';

import './components/link-dropdown';
import './components/sidebar';
import './components/mobile-navigation';
import './components/progressbar';
import './components/user-info';
import './components/news';
import './components/application-carousel';
import './components/organisation-carousel';
import './components/quiz-questions';
import './components/datasheet';
import './components/average-losses';
import './components/expiry-notification-strip';

import './components/gtm';

import '../components/news-filters';
import '../components/date-range';
import '../components/stats-by-state';
import '../components/popups';
import '../components/forms';
import '../components/forms-embeds';
import '../components/forms/date-picker';
import '../components/tables';
import '../components/toggle';
import '../components/sub-nav-carousel';
import '../components/card-accordion-toggle';
import '../components/product-accordion-toggle';
import '../components/grid-check';
import '../components/banner-alert';
import '../components/smoothscroll';
import './components/large-buttons';

import '../charts/line-chart';

fitty('.fitty', { minSize: 16, maxSize: 110 });

const btt = document.querySelector('.js-btt');

if (btt) {
    btt.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.account__body').scrollTo(0, 0);
    });
}